module.exports = __webpack_public_path__ + "static/img/solution03.192fe59c.webp";